/**
 * 组件使用场景：针对大域订单发起争议处理
 * 组件使用 -> API:dispatch.initiateDispute.show(id) 展开model
 *
 * */
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Modal, Form, Input, message } from 'antd';
import { Provider, connect } from '@souche-f2e/muji';
import store, { dispatch } from '@@/store';
const mapStateToProps = (rootState) => ({ initiateDispute: rootState.initiateDispute });
class DaYuInitiateDisputeComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            count: 0,
        };
        this.handleOk = this.handleOk.bind(this);
        this.afterClose = this.afterClose.bind(this);
        this.resetForm = this.resetForm.bind(this);
        this.onhandleCancel = this.onhandleCancel.bind(this);
        this.handleChangeText = this.handleChangeText.bind(this);
    }
    afterClose() {
        dispatch.initiateDispute.resetState();
        this.resetForm();
        this.setState({
            count: 0,
        });
    }
    onhandleCancel() {
        const props = this.props;
        if (props.initiateDispute.confirmLoading) {
            message.warning('正在发起争议中，请稍后再试');
        }
        else {
            dispatch.initiateDispute.hide();
        }
    }
    // 重置选择框
    resetForm(resetList) {
        const props = this.props;
        props.form.resetFields(resetList);
    }
    handleOk() {
        const props = this.props;
        props.form.validateFields((err, values) => {
            if (!err) {
                dispatch.initiateDispute.confirmDisputeDeal(props.form);
            }
        });
    }
    handleChangeText(e) {
        const count = e.target.value.length;
        this.setState({
            count,
        });
    }
    render() {
        const props = this.props;
        const { getFieldDecorator } = props.form;
        const { visibles } = props.initiateDispute;
        return (<div>
        <Modal centered title="发起争议处理" okText="确认" onOk={this.handleOk} cancelText="取消" onCancel={this.onhandleCancel} visible={visibles} afterClose={this.afterClose}>
          <Form labelCol={{ span: 4 }} wrapperCol={{ span: 20 }} labelAlign="right">
            <Form.Item label="扣除金额">
              <span className="ant-form-text">2000元</span>
            </Form.Item>
            <Form.Item label="处理类型">
              {getFieldDecorator('dealType', {
            rules: [
                {
                    required: true,
                },
                {
                // validator: true
                },
            ],
            initialValue: '卖家违约',
        })(<Input disabled={true}/>)}
            </Form.Item>
            <Form.Item colon={false} label="备注">
              {getFieldDecorator('disputeReason', {
            rules: [
                {
                    required: true,
                    message: '请输入申诉内容',
                },
                {
                    max: 100,
                    message: '限100字',
                },
            ],
        })(<Input.TextArea placeholder="请输入申诉内容" autoSize={{
            minRows: 6,
            maxRows: 8,
        }} maxLength={100} onChange={this.handleChangeText}/>)}
              <span style={{ position: 'absolute', top: -15, right: 7 }}>
                {this.state.count}/100
              </span>
            </Form.Item>
          </Form>
        </Modal>
      </div>);
    }
}
DaYuInitiateDisputeComponent.defaultProps = {};
const InitiateDisputeFrom = Form.create({})(DaYuInitiateDisputeComponent);
const newsInitiateDisputeComponent = connect(mapStateToProps, null, null, { forwardRef: true })(InitiateDisputeFrom);
export default newsInitiateDisputeComponent;
/**
 * API
 * */
let componentRef = '';
const createInitiateDispute = () => {
    const div = document.createElement('div');
    div.className = 'souche-initiate-discupt';
    document.body.appendChild(div);
    // @ts-ignore
    const component = (
    // @ts-ignore
    <Provider store={store}>
      {React.createElement(newsInitiateDisputeComponent, {
        // @ts-ignore
        ref: (ref) => {
            componentRef = ref;
        },
        _removeElement() {
            ReactDOM.unmountComponentAtNode(div);
            document.body.removeChild(div);
        },
    })}
    </Provider>);
    ReactDOM.render(component, div);
};
export function showDaYuDispute({ data, callback }) {
    if (!componentRef) {
        createInitiateDispute();
    }
    dispatch.initiateDispute.showTrans({ data, callback });
}
